import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router";

import DeviceGroupsView from "components/ReportTemplates/DeviceGroups/DeviceGroupsView";
import ReportNoteSectionsView from "components/ReportTemplates/ReportNoteSections/ReportNoteSectionsView";
import ReportNoteTemplatesView from "components/ReportTemplates/ReportNoteTemplates/ReportNoteTemplatesView";
import { USER_ROLES } from "static/constants";
import { useSelector } from "react-redux";

const useReportTemplates = () => {
  const { view } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useSelector((state) => state.auth);
  const [currentTab, setCurrentTab] = useState(view ?? "templates");
  const isAllowedUser = [USER_ROLES.ADMIN, USER_ROLES.CLINIC_ADMIN].includes(
    currentUser?.role
  );

  const tabs = useMemo(() => {
    const baseTabs = [
      {
        label: "Report Templates",
        value: "templates",
        component: <ReportNoteTemplatesView />,
      },
      {
        label: "Report Notes",
        value: "notes",
        component: <ReportNoteSectionsView />,
      },
    ];
    if (isAllowedUser) {
      baseTabs.push({
        label: "Device Groups",
        value: "device-groups",
        component: <DeviceGroupsView />,
      });
    }
    return baseTabs;
  }, [isAllowedUser]);

  useEffect(() => {
    if (!isAllowedUser && view === "device-groups") {
      navigate("/report-templates/templates", { replace: true });
      setCurrentTab("templates");
    }
  }, [isAllowedUser, view]);

  useEffect(() => {
    if (view && view !== currentTab) {
      setCurrentTab(view);
    }
  }, [currentTab, view]);

  const onTabChange = (newView) => {
    if (newView === currentTab) return;

    navigate(`/report-templates/${newView}`);
    setCurrentTab(newView);
  };

  return { tabs, currentTab, onTabChange };
};

export default useReportTemplates;
